import React from 'react';
import { Table, Empty, Button, Input, Form, Select, Icon,InputNumber } from 'antd';
const { Option } = Select;
const InputGroup = Input.Group;



class DetalleDestinoModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleSearchAutocomplete = async (value) => {
        const result = this.props.debe.filter(item => {
            return (item.cuentaContable + ' - ' + item.nombre).toUpperCase().match(value.toUpperCase());
        }).slice(0, 75);
        this.props.form.setFieldsValue({ planesCuentaAutocomplete: result });
    };

    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form;

        getFieldDecorator('planesCuentaAutocomplete', {
            initialValue: this.props.debe
                .filter(m => { return m.id === 0 })
        });
        return (
            <div>
                <Table
                    style={{ overflowX: 'auto' }}
                    className={'table-referencia'}
                    size="small"
                    pagination={false}
                    dataSource={this.props.dataSource}
                    rowKey={record => record.identifier}
                    locale={{
                        emptyText: <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description='Pulse el bot+on "+ Agregar".'
                        />
                    }}
                    columns={[
                        {
                            key: 'remove-button',
                            align: 'center',
                            width: '50px',
                            render: (value, row) => (
                                <span>
                                    <div className="custom-options">
                                        <Button
                                            type="danger"
                                            icon="delete"
                                            size={"small"}
                                            onClick={() => this.props.onRemove(value)}
                                        />
                                    </div>
                                </span>
                            )
                        },
                        {
                            title: 'Debe',
                            dataIndex: 'idDebe',
                            key: 'idDebe',
                            width: '190px',
                            render: (value, row) => {
                                return (
                                    <Form.Item>
                                        <InputGroup compact>
                                            {this.props.onGetFieldDecorator(`idDebe[${row.identifier}]`, {
                                                initialValue: value ? { key: value } : undefined,
                                                validateTrigger: ['onChange'],
                                                rules: [{
                                                    required: true,
                                                    message: 'Requerido'
                                                }]
                                            })(
                                                <Select showSearch labelInValue
                                                    style={{ width: `calc(100% - 40px)` }}
                                                    placeholder={"Búsqueda de Cuenta Contable"}
                                                    optionFilterProp="children"
                                                    showArrow={false}
                                                    onSearch={this.handleSearchAutocomplete}
                                                >
                                                    {this.props.debe.map(item => (
                                                        <Option key={item.id} value={item.id}>{item.cuentaContable + ' - ' + item.nombre}</Option>
                                                    ))}
                                                </Select>
                                            )}
                                            <Button
                                                className="btn-autocomplete"
                                                style={{ width: '40px', fontSize: '14px' }}
                                                icon={this.props.form.getFieldValue('idPlanCuentaVenta') ? 'close' : 'search'}
                                                onClick={() => this.props.form.setFieldsValue({ idPlanCuentaVenta: undefined })}
                                            />
                                        </InputGroup>
                                    </Form.Item>
                                );
                            }
                        },
                        {
                            title: 'Haber',
                            dataIndex: 'idHaber',
                            key: 'idHaber',
                            width: '190px',
                            render: (value, row) => {
                                return (
                                    <Form.Item>
                                        {/*      {this.props.onGetFieldDecorator(`idHaber[${row.identifier}]`, {
                                        initialValue: value ? { key: value } : undefined,
                                        validateTrigger: ['onChange'],
                                        rules: [{
                                            required: true,
                                            message: 'Requerido'
                                        }]
                                    })(
                                        <Select showSearch labelInValue
                                            placeholder={"Seleccione Haber"}
                                            optionFilterProp="children"
                                            showArrow={false}
                                            onSearch={this.handleSearchAutocomplete} 
                                        >
                                          {getFieldValue('planesCuentaAutocomplete').map(item => (
                                                <Option key={item.id} value={item.id}>{item.cuentaContable + ' - ' + item.nombre}</Option>
                                            ))}
                                        </Select>
                                    )} */}

                                        <InputGroup compact>
                                            {this.props.onGetFieldDecorator(`idHaber[${row.identifier}]`, {
                                                initialValue: value ? { key: value } : undefined,
                                                validateTrigger: ['onChange'],
                                                rules: [{
                                                    required: true,
                                                    message: 'Requerido'
                                                }]
                                            })(
                                                <Select showSearch labelInValue
                                                    style={{ width: `calc(100% - 40px)` }}
                                                    placeholder={"Búsqueda de Cuenta Contable"}
                                                    optionFilterProp="children"
                                                    showArrow={false}
                                                    onSearch={this.handleSearchAutocomplete}
                                                >
                                                    {this.props.haber.map(item => (
                                                        <Option key={item.id} value={item.id}>{item.cuentaContable + ' - ' + item.nombre}</Option>
                                                    ))}
                                                </Select>
                                            )}
                                            <Button
                                                className="btn-autocomplete"
                                                style={{ width: '40px', fontSize: '14px' }}
                                                icon={this.props.form.getFieldValue('idHaber') ? 'close' : 'search'}
                                                onClick={() => this.props.form.setFieldsValue({ idHaber: undefined })}
                                            />
                                        </InputGroup>

                                    </Form.Item>
                                );
                            }
                        },
                        {
                            title: 'Porcentaje',
                            dataIndex: 'porcentaje',
                            key: 'porcentaje',
                            width: '90px',
                            render: (value, row) => {
                                return (
                                    <Form.Item>
                                        {this.props.onGetFieldDecorator(`porcentaje[${row.identifier}]`, {
                                            initialValue: parseInt(value),
                                            rules: [{
                                                required: true,
                                                message: 'Requerido',
                                            }]
                                        })(

                                            <InputNumber
                                                defaultValue={100}
                                                placeholder="Ingresar Porcentaje"
                                                min={0}
                                                max={100}
                                                formatter={value => `${value}%`}
                                                parser={value => value.replace('%', '')}
                                            />
                                        )}
                                    </Form.Item>
                                );
                            }
                        }



                    ]}
                />
            </div>
        );

    }
}

export default Form.create()(DetalleDestinoModal)